module.exports = __webpack_public_path__ + "img/chevron-down.1e1d6a3e.svg";